import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import { modelOf } from '../../../prop-types';
import AdStore from '../../../store/AdStore';
import ConfigStore from '../../../store/ConfigStore';
import AdZones from '../../../types/AdZones';
import BannerSlider from '../BannerSlider/BannerSliderSlides';

// Figma 385 x 120.
const ASPECT_RATIO = 3.2;

const CheckoutSummaryBanner = ({
  adStore,
  configStore,
  className,
  searchParams,
  overrideSettings,
}) => {
  const ads = adStore.getGlobalAdsByAdZone(AdZones.CHECKOUT_SUMMARY_BANNER);

  if (!ads || ads.length === 0) {
    return null;
  }

  const bannerSettings = {
    arrows: false,
    dots: false,
    infinite: true,
    centerMode: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    ...overrideSettings,
  };

  return (
    <BannerSlider
      adZone={AdZones.CHECKOUT_SUMMARY_BANNER}
      searchParams={{
        ...searchParams,
      }}
      className={classNames('CheckoutSummaryBanner', className)}
      aspectRatio={ASPECT_RATIO}
      maximumCrossAxisSize={configStore.banner.checkout.summaryHeight}
      overrideSettings={bannerSettings}
      preLoadedAds={ads}
    />
  );
};

CheckoutSummaryBanner.propTypes = {
  adStore: modelOf(AdStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  className: PropTypes.string,
  overrideSettings: PropTypes.object,
  searchParams: PropTypes.object,
};

export default inject(
  'adStore',
  'configStore'
)(observer(CheckoutSummaryBanner));
